import React, { useState, useEffect } from "react";
import "../Styles/AboutUsTwo.css";
import AboutBigImg from "../assets/Header-Images/AboutusBig.png";
import { FaHandsHelping, FaEye, FaSeedling } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const icons = [<FaHandsHelping />, <FaEye />, <FaSeedling />];

const AboutUs = () => {
    const { t } = useTranslation();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const cardData = t("aboutUsTwo.reasons", { returnObjects: true });

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <>
            <div className="about-container">
                <section className="about-section">
                    <div className="about-text">
                        <span className="about-badge">About Us</span>
                        <h2 className="about-title">{t("aboutUs.title")}</h2>
                        <p className="about-subtitle">
                            <i>{t("aboutUs.subtitle")}</i>
                        </p>
                        <p className="about-description">
                            {t("aboutUs.description1")}
                        </p>

                        {!isMobile && (
                            <p className="about-description">
                                {t("aboutUs.description2")}
                            </p>
                        )}
                    </div>

                    <div className="about-images">
                        <div className="main-image-container">
                            <img src={AboutBigImg} alt="Factory" className="main-image" />
                        </div>
                    </div>

                    {isMobile && (
                        <div className="about-text">
                            <p className="about-description">
                                {t("aboutUs.description2")}
                            </p>
                        </div>
                    )}
                </section>
            </div>

            <div className="about-cards-container">
                {cardData.map((item, index) => (
                    <div className="about-card" key={index}>
                        <div className="cards-container">
                            <span className="card-icon">{icons[index]}</span>
                            <h3>{item.h1}</h3>
                        </div>
                        <p>{item.p}</p>
                    </div>
                ))}
            </div>
        </>

    );
};

export default AboutUs;